const messages = {
  es: {
    translations: {
      signup: {
        title: "Registro",
        toasts: {
          success:
            "¡El usuario ha sido creado satisfactoriamente! ¡Ahora inicia sesión!",
          fail: "Error creando el usuario. Verifica la data reportada.",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          company: "Nombre de la Empresa",
          phone: "Whatsapp (COD + NÚMERO)",
        },
        buttons: {
          submit: "Regístrate",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!",
        },
      },
      ticketInfo: {
        copyPhone: "Copiar teléfono",
        quickMessages: "Respuestas rápidas",
        phonecopied: "¡Teléfono copiado al portapapeles!",
        noPhone: "No hay teléfono disponible para copiar",
        copyError: "Error al copiar el teléfono",
        invalidPhoneFormat: "Formato de teléfono inválido",
      },
      login: {
        title: "Inicio de Sesión",
        welcome: "Bienvenido de nuevo",
        loginInstruction: "Introduce tus datos para acceder a tu cuenta",
        form: {
          email: "Correo Electrónico",
          password: "Contraseña",
          button: "Ingresar",
        },
        buttons: {
          submit: "Ingresa",
          register: "¿No tienes cuenta? ¡Regístrate!",
        },
      },
      companies: {
        title: "Registrar Empresa",
        form: {
          name: "Nombre de la Empresa",
          plan: "Plan",
          token: "Token",
          submit: "Registrar",
          success: "Empresa creada con éxito!",
        },
      },
      auth: {
        toasts: {
          success: "¡Inicio de sesión exitoso!",
        },
        dueDate: {
          expiration: "Suscripción caducará en",
          days: "días!",
          day: "día!",
          expirationToday: "Su suscripción termina hoy!",
        },
        token: "Token",
      },
      dashboard: {
        filters: "Filtros",
        filter: "FILTRAR ",
        tabs: {
          indicators: "Indicadores",
          assessments: "Evaluaciones",
          attendants: "Agentes",
          attendance: "Atenciones",
          charts: "Gráficos",
          satisfaction: "Satisfacción",
        },
        charts: {
          perDay: {
            title: "Tickets hoy: ",
          },
          messagesReceivedVsSent: "Mensajes Recibidos vs Enviados",
          ticketStatus: "Estado de los Tickets",
          attendanceByStatus: "Atenciones por Estado",
          newContactsVsGroups: "Nuevos Contactos vs Grupos",
          totalTickets: "Total de Tickets",
        },
        cards: {
          inAttendance: "Atención actual",
          waiting: "Esperando",
          activeAttendants: "Agentes Activos",
          finalized: "Finalizados",
          newContacts: "Nuevos Contactos",
          totalReceivedMessages: "Total de Mensajes Recibidas",
          totalSentMessages: "Total de Mensajes Enviadas",
          averageServiceTime: "T.P. de Atención",
          averageWaitingTime: "T.P. de Espera",
          status: "Status (Actual)",
          activeTickets: "Tickets Activos",
          passiveTickets: "Tickets Pasivos",
          groups: "Grupos",
          inService: "En Atención",
          calling: "Llamando",
          finished: "Finalizados",
          newLeads: "Nuevos Contactos",
          receivedMessages: "Mensajes Recibidos",
          sentMessages: "Mensajes Enviados",
          avgServiceTime: "T.M. Atención",
          avgWaitTime: "T.M. Espera",
          activeTicketsCount: "Tickets Activos",
          passiveTicketsCount: "Tickets Pasivos",
          totalTicketsCount: "Total de Tickets",
        },
        users: {
          name: "Nombre",
          numberAppointments: "Total de tickets",
          statusNow: "Actual",
          totalCallsUser: "Total de atención por usuario",
          totalAttendances: "Total de atenciones",
          score: "Puntuación",
          ratedAttendances: "Evaluados",
          totalAttendances: "Total",
          avgWaitTime: "T.M. Espera",
          avgAttendanceTime: "T.M. Atención",
          online: "En línea",
          offline: "Desconectado",
        },
        date: {
          initialDate: "Fecha Inicial",
          finalDate: "Fecha Final",
          until: "hasta",
          apply: "Aplicar",
        },
        licence: {
          available: "Disponíble hasta",
        },
        assessments: {
          totalCalls: "Total de Tickets",
          callsWaitRating: "Tickets aguardando evaluación",
          callsWithoutRating: "Ticket sin evaluación",
          ratedCalls: "Tickets evaluados",
          evaluationIndex: "Índice de evaluación",
          score: "Puntaje",
          prosecutors: "Promotores",
          neutral: "Neutrales",
          detractors: "Dectratores",
          mainIndicators: "Indicadores Principales",
          attendanceStatistics: "Estadísticas de Atención",
          evaluationIndex: "Índice de Evaluación",
          npsResearch: "Investigación de Satisfacción (NPS)",
          analysisAndCharts: "Análisis y Gráficos",
          attendants: "Agentes",
          noAttendantsAvailable: "Ningún agente disponible",
          loading: "Cargando dashboard...",
        },
      },
      reports: {
        title: "Reporte de Pesquisas Realizadas",
        operator: "Agente",
        period: "Período",
        until: "Hasta",
        date: "Fecha",
        reportTitle: "Relatorios",
        calls: "Atenciones",
        search: "Pesquisas",
        durationCalls: "Duración de la atención",
        grupoSessions: "Atención en grupos grupos",
        startDate: "Fecha de inicio",
        endDate: "Fecha de finalización",
        table: {
          id: "Ticket",
          user: "Usuario",
          dateOpen: "Fecha de Apertura",
          dateClose: "Fecha de Cierre",
          NPS: "NPS",
          status: "Estado",
          whatsapp: "Conexión",
          queue: "Cola",
          actions: "Acciones",
          lastMessage: "Últ. Mensaje",
          contact: "Cliente",
          supportTime: "Tiempo de Atención",
        },
        buttons: {
          filter: "Aplicar Filtro",
          onlyRated: "Solo Evaluados",
        },
        groupTicketsReports: {
          timezone: "America/Monterrey",
          msgToast: "Generando relatorio compactado, por favor espere.",
          errorToast: "Erro ao generar relatorio",
          back: "Volver",
          groupServiceReport: "Relatorio de Atención en Grupos",
          loading: "Cargando...",
          contact: "Contacto",
          dateOpen: "Fecha de Apertura",
          dateLastUpdated: "Fecha Ultima Actualización",
          agent: "Agente",
          agentClosed: "Agente(cerró)",
          waitingAssistance: "Esperando atención",
          process: "En proceso",
        },
        researchReports: {
          response: "respuesta",
          active: "(Activa)",
          inactive: "(Inactiva)",
          quantity: "Cantidade",
          percentage: "porcentaje",
          title: "Relatorio de Pesquisas Realizadas",
          activeSearch: "Pesquisa activa",
          inactiveSearch: "Pesquisa inactiva",
        },
        ticketDurationDetail: {
          msgToast: "Generando relatorio compactado, por favor espere.",
          title: "Relatorio de Duración de la Atención",
          startService: "Início de la Atención",
          lastUpdated: "Última actualización",
          lastAgent: "Último agente",
          durationFinished: "Duración después de finalizado",
        },
        ticketDuration: {
          title: "Relatorio de Duración de Atención",
          contact: "Contacto",
          open: "Abiertos",
          pending: "Pendientes",
          finished: "Finalizados",
          durationFinished: "Duración de los finalizados",
          durationAfterFinished: "Duración después de finalizado",
          actions: "Acciones",
        },
        ticketReports: {
          msgToast: "Generando relatorio compactado, por favor aguarde.",
          title: "Relatrio de Atención",
        },
        exportExcel: {
          title: "Reportes de Atención",
          startDate: "Fecha inicial",
          endDate: "Fecha final",
          notInformed: "No informado",
          columns: {
            id: "ID",
            connection: "Conexión",
            contact: "Contacto",
            user: "Usuario",
            queue: "Fila",
            status: "Estado",
            lastMessage: "Último Mensaje",
            openDate: "Fecha Apertura",
            openTime: "Hora Apertura",
            closeDate: "Fecha Cierre",
            closeTime: "Hora Cierre",
            supportTime: "Tiempo de Atención",
            nps: "NPS",
          },
        },
        pdf: {
          title: "Relación de Atenciones Realizadas",
          exportTitle: "Relación de Atenciones en Grupos Realizadas",
        },
      },
      apps: {
        title: "Centro de Aplicaciones",
        subtitle: "Explora y accede a todas las aplicaciones e integraciones disponibles para tu empresa",
        search: "Buscar aplicaciones...",
        filters: {
          all: "Todos",
          available: "Disponibles",
          comingSoon: "Próximamente",
          configured: "Configurados",
        },
        status: {
          available: "Disponible",
          unavailable: "No disponible",
          comingSoon: "Próximamente",
        },
        buttons: {
          configure: "Configurar",
          access: "Acceder",
          payNow: "Pagar Ahora",
        },
        messages: {
          noApps: "Ninguna aplicación encontrada",
          comingSoon: "🎉 ¡Novedad próximamente! Esta funcionalidad estará disponible pronto.",
        },
        apps: {
          whatsappOficial: {
            name: "WhatsApp Oficial",
            description: "Configura la API oficial de WhatsApp Business para envío de mensajes",
          },
          telegram: {
            name: "Telegram",
            description: "Configura integración con Telegram para atención vía bot",
          },
          groqAi: {
            name: "Groq AI",
            description: "Configura API de Groq para IA ultrarrápida con modelos Llama y Mixtral",
          },
          deepseek: {
            name: "DeepSeek",
            description: "Configura API de DeepSeek para usar modelos de IA avanzados",
          },
          mercadoLivre: {
            name: "Mercado Libre",
            description: "Integra con Mercado Libre para gestionar ventas y atención",
          },
          woocommerce: {
            name: "WooCommerce",
            description: "Conecta tu tienda WooCommerce para sincronizar pedidos y clientes",
          },
          tiktok: {
            name: "TikTok",
            description: "Configura integración con TikTok para atención y mensajes",
          },
          openai: {
            name: "OpenAI (ChatGPT)",
            description: "Configura API Key de OpenAI para usar GPT-3.5, GPT-4 y otros modelos",
          },
          gemini: {
            name: "Google Gemini",
            description: "Configura API Key de Google Gemini para usar IA de Google",
          },
          notificamehub: {
            name: "NotificameHub",
            description: "Configura canales de comunicación WhatsApp, Instagram y Facebook",
          },
          calAgenda: {
            name: "Cal Agenda",
            description: "Configura tu integración con Cal.com para gestionar citas",
          },
          wavoip: {
            name: "Wavoip",
            description: "Configura tu integración con Wavoip para llamadas VoIP",
          },
          help: {
            name: "Ayuda",
            description: "Accede a tutoriales, documentación y soporte para usar el sistema",
          },
          integration: {
            name: "Integración",
            description: "Configura integraciones con sistemas externos y automatiza procesos",
          },
          api: {
            name: "API",
            description: "Gestiona tus claves de API y configura endpoints personalizados",
          },
          talkIa: {
            name: "Talk.IA",
            description: "Configura asistentes de IA y prompts personalizados para automatización",
          },
          backup: {
            name: "Copia de Seguridad Individual",
            description: "Realiza copia de seguridad y restaura tus datos de forma segura",
          },
          files: {
            name: "Lista de Archivos",
            description: "Gestiona todos los archivos enviados y recibidos en el sistema",
          },
        },
      },
      settings: {
        success: "Configurações guardadas exitosamente.",
        title: "Configuraciones",
        tabs: {
          options: "Opciones",
          plans: "Planes",
          helps: "Ayuda",
          companies: "Empresas",
        },
        settings: {
          userCreation: {
            name: "Creación de usuario",
            options: {
              enabled: "Activado",
              disabled: "Desactivado",
            },
          },
          tabs: {
            options: "Opciones",
            schedules: "Horarios",
            plans: "Planes",
            help: "Ayuda",
          },
          options: {
            disabled: "Deshabilitado",
            enabled: "Habilitado",
            updating: "Actualizando...",
            open: "Abierto",
            pending: "Pendiente",
            creationCompanyUser: "Creación de Empresa/Usuario",
            evaluations: "Evaluaciones",
            officeScheduling: "Programación de Horario de Oficina",
            queueManagement: "Gestión por Cola",
            companyManagement: "Gestión por Empresa",
            connectionManagement: "Gestión por Conexión",
            sendGreetingAccepted: "Enviar saludo al aceptar el ticket",
            sendMsgTransfTicket:
              "Enviar mensaje de transferencia de sector/agente",
            checkMsgIsGroup: "Ignorar Mensajes de Grupos",
            chatBotType: "Tipo de Bot",
            userRandom: "Elegir agente al azar",
            buttons: "Botones",
            acceptCallWhatsapp: "¿Informar que no acepta llamadas en WhatsApp?",
            sendSignMessage: "Permite al agente elegir ENVIAR Firma",
            sendGreetingMessageOneQueues:
              "Enviar saludo cuando hay solo 1 sector",
            sendQueuePosition: "Enviar mensaje con la posición de la cola",
            sendFarewellWaitingTicket:
              "Enviar mensaje de despedida en Esperando",
            acceptAudioMessageContact:
              "¿Acepta recibir audio de todos los contactos?",
            enableLGPD: "Habilitar tratamiento LGPD",
            requiredTag: "Etiqueta obligatoria para cerrar ticket",
            closeTicketOnTransfer:
              "Cerrar ticket al transferir a otra cola",
            transferredTicketStatus:
              "Estado del ticket al transferir con usuario",
            DirectTicketsToWallets:
              "Mover cliente automáticamente a cartera",
            enableProfanityMonitor:
              "Monitorear palabras ofensivas en conversaciones",
            showNotificationPending:
              "Mostrar notificación para tickets pendientes",
            copyContactPrefix: "Sigla para Copia de Contactos",
            copyContactPrefixPlaceholder: "Ej: COPIA_"
          },
          customMessages: {
            sendQueuePositionMessage: "Mensaje de posición en la cola",
            AcceptCallWhatsappMessage:
              "Mensaje para informar que no acepta llamadas",
            greetingAcceptedMessage: "Mensaje de Saludo al aceptar ticket",
            transferMessage:
              "Mensaje de transferencia - ${queue.name} = cola destino",
          },
          LGPD: {
            title: "LGPD",
            welcome: "Mensaje de bienvenida (LGPD)",
            linkLGPD: "Enlace de política de privacidad",
            obfuscateMessageDelete: "Ofuscar mensaje eliminado",
            alwaysConsent: "Siempre solicitar consentimiento",
            obfuscatePhoneUser: "Ofuscar número de teléfono para usuarios",
            enabled: "Habilitado",
            disabled: "Deshabilitado",
          },
        },
      },
      companiesList: {
        title: "Empresas",
        searchPlaceholder: "Buscar por nombre, email o teléfono...",
        filterStatus: "Estado",
        filterStatusAll: "Todos",
        table: {
          name: "NOMBRE",
          email: "EMAIL",
          phone: "TELÉFONO",
          plan: "PLAN",
          status: "ESTADO",
          dueDate: "VENCIMIENTO",
          lastAccess: "ÚLTIMO ACCESO",
          actions: "ACCIONES",
        },
        status: {
          active: "Activo",
          inactive: "Inactivo",
          unlimited: "Ilimitado",
        },
        buttons: {
          add: "Agregar Empresa",
          edit: "Editar",
          delete: "Eliminar",
          view: "Ver",
        },
        messages: {
          noCompanies: "No hay empresas encontradas",
          loading: "Cargando empresas...",
          confirmDelete: "¿Está seguro de que desea eliminar esta empresa?",
          deleteSuccess: "Empresa eliminada exitosamente",
          editSuccess: "Empresa actualizada exitosamente",
          addSuccess: "Empresa agregada exitosamente",
        },
        pagination: {
          showing: "Mostrando",
          to: "a",
          of: "de",
          previous: "Anterior",
          next: "Siguiente",
        },
      },
      announcements: {
        title: "Informativos",
        searchPlaceholder: "Búsqueda",
        active: "Activo",
        inactive: "Inactivo",
        buttons: {
          add: "Nuevo Informativo",
          contactLists: "Listas de Informativos",
        },
        table: {
          priority: "Prioridad",
          title: "Título",
          text: "Texto",
          mediaName: "Archivo",
          status: "Estado",
          actions: "Acciones",
        },
        dialog: {
          edit: "Edición de Informativo",
          add: "Nuevo Informativo",
          update: "Editar Informativo",
          readonly: "Solo Visualización",
          form: {
            priority: "Prioridad",
            title: "Título",
            text: "Texto",
            mediaPath: "Archivo",
            status: "Estado",
            high: "Alta",
            medium: "Media",
            low: "Baja",
            active: "Activo",
            inactive: "Inactivo",
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Cerrar",
            attach: "Adjuntar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        toasts: {
          success: "Operación realizada exitosamente",
          deleted: "Registro eliminado",
        },
      },
      allConnectionsList: {
        title: "Gestionar Conexiones",
        searchPlaceholder: "Escribe el nombre de la empresa...",
        filterStatus: "Estado",
        filterStatusAll: "Todos",
        filterStatusConnected: "Conectadas",
        filterStatusDisconnected: "Desconectadas",
        clearFilters: "Limpiar Filtros",
        stats: {
          totalCompanies: "Total de Empresas",
          connectedConnections: "Conexiones Activas",
          disconnectedConnections: "Desconectadas",
        },
        table: {
          company: "Empresa",
          active: "Activas",
          inactive: "Inactivas",
          total: "Total",
          actions: "Acciones",
        },
        buttons: {
          edit: "Editar",
          view: "Visualizar",
          delete: "Eliminar",
        },
        messages: {
          noConnections: "Ninguna conexión encontrada",
          loading: "Cargando conexiones...",
          confirmDelete: "¿Está seguro de que desea eliminar esta conexión?",
          deleteSuccess: "Conexión eliminada exitosamente",
          editSuccess: "Conexión actualizada exitosamente",
        },
        pagination: {
          showing: "Mostrando",
          to: "a",
          of: "de",
          previous: "Anterior",
          next: "Siguiente",
        },
      },
      todo: {
        newTask: "Nueva Tarea",
        add: "Agregar",
        task: "Tareas",
      },
      contactImportWpModal: {
        title: "Exportar Contactos para Excel",
        buttons: {
          downloadModel: "Download - modelo de excel para importación",
          closed: "Cerrar",
          import: "Seleccione el archivo de excel para importar los Contactos",
        },
      },
      connections: {
        title: "Conexiones",
        waitConnection: "Espere... ¡Las conexiones serán reiniciadas!",
        newConnection: "Nueva Conexión",
        restartConnections: "Reiniciar Conexiones",
        callSupport: "Llamar Soporte",
        newConnection: "Nueva Conexión",
        connectYourServiceChannelsToReceiveMessagesAndStartConversationsWithYourCustomers:
          " Conecta tus canales de atención para recibir mensajes e iniciar conversaciones con tus clientes.",
        client: "Cliente",
        connectedConnections: "Conexiones conectadas",
        disconnectedConnections: "Conexiones desconectadas",
        totalConnections: "Total de conexiones",
        total: "Total",
        connections: " Conexiones:",
        toasts: {
          deleted:
            "¡La conexión de WhatsApp ha sido borrada satisfactoriamente!",
          closedimported:
            "Estamos cerrando los tickets importados, por favor espere.",
        },
        confirmationModal: {
          closedImportedTitle: "Cerrar tickets importados",
          closedImportedMessage:
            "¿Seguro? Todos los tickets importados seran cerrados.",
          deleteTitle: "Borrar",
          deleteMessage: "¿Estás seguro? Este proceso no puede ser revertido.",
          disconnectTitle: "Desconectar",
          disconnectMessage: "Estás seguro? Deberá volver a leer el código QR",
        },
        buttons: {
          add: "Agrega WhatsApp",
          disconnect: "Desconectar",
          tryAgain: "Inténtalo de nuevo",
          qrcode: "QR CODE",
          newQr: "Nuevo QR CODE",
          closedImported: "Cerrar todos los tickets Importados",
          preparing: "Preparando mensajes para importación",
          importing: "Importando Mensajes del WhatsApp",
          newQr: "Nuevo QR CODE",
          processed: "Processado",
          in: "de",
          connecting: "Conectando",
        },
        typography: {
          processed: "Processado",
          in: "de",
          date: "Fecha del mensaje",
        },
        toolTips: {
          disconnected: {
            title: "No se pudo iniciar la sesión de WhatsApp",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y vuelva a intentarlo o solicite un nuevo código QR",
          },
          qrcode: {
            title: "Esperando la lectura del código QR",
            content:
              "Haga clic en el botón 'CÓDIGO QR' y lea el Código QR con su teléfono celular para iniciar la sesión",
          },
          connected: {
            title: "Conexión establecida",
          },
          timeout: {
            title: "Se perdió la conexión con el teléfono celular",
            content:
              "Asegúrese de que su teléfono celular esté conectado a Internet y que WhatsApp esté abierto, o haga clic en el botón 'Desconectar' para obtener un nuevo código QR",
          },
        },
        table: {
          name: "Nombre",
          status: "Estado",
          lastUpdate: "Última Actualización",
          default: "Por Defecto",
          actions: "Acciones",
          session: "Sesión",
          number: "Número de Whatsapp",
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Servicio existente",
        },
        form: {
          message: "Hay un ticket abierto para este contacto:",
          user: "Agente",
          queue: "Fila",
          messageWait: "Este contacto ya está en espera.",
        },
      },
      showTicketLogModal: {
        title: {
          header: "Historial",
        },
        options: {
          create: "Ticket creado.",
          chatBot: "ChatBot iniciado.",
          queue: " - Fila definida.",
          open: " inició la atención.",
          access: "accedió al ticket.",
          transfered: "transfirió el ticket.",
          receivedTransfer: "recibió el ticket transferido.",
          pending: "devolvió a la fila.",
          closed: "cerró el ticket",
          reopen: "reabrió el ticket",
          redirect: "- redirigido",
          clientClosed: "Cliente cerró el ticket",
        },
      },
      whatsappModal: {
        title: {
          add: "Agregar Conexión",
          edit: "Editar Conexión",
        },
        tabs: {
          general: "General",
          messages: "Mensajes",
          assessments: "Evaluaciones",
          integrations: "Integraciones",
          schedules: "Horario de trabajo",
        },
        form: {
          importOldMessagesEnable: "Importar mensajes del celular",
          importOldMessages: "Fecha de inicio",
          importRecentMessages: "Fecha Final",
          importLast7Days: "Últimos 7 días",
          importOldMessagesGroups: "Importar mensajes de grupo",
          closedTicketsPostImported: "Cerrar tickets después de la importación",
          name: "Nombre",
          queueRedirection: "Redirección de Fila",
          queueRedirectionDesc:
            "Seleccione una fila para los contactos que no tienen una fila para redirigir",
          default: "Por Defecto",
          group: "Permitir grupos",
          timeSendQueue: "Tiempo en minutos para redireccionar a la fila",
          importAlert:
            "ATENCIÓN: Guardando, su conexión será cerrada, usted tendrá que volver a leer el QR Code para importar los mensajes",
          groupAsTicket: "Grupos como Ticket",
          timeCreateNewTicket: "Iniciar un nuevo ticket en *n* minutos",
          maxUseBotQueues:
            "Cantidad máxima de veces que el chatbot va a ser enviado",
          timeUseBotQueues: "Tiempo en minutos para nuevo envío del chatbot",
          maxUseInactiveTime: "Enviar flujo de inactividad x veces",
          timeToReturnQueue: "Tiempo para retornar al sector en minutos",
          timeAwaitActiveFlow: "Tiempo para esperar activación del flujo",
          expiresTicket: "Cerrar chats abiertos após *n* horas",
          expiresTicketNPS:
            "Cerrar chats aguardando la evaluacion luego de x minutos",
          maxUseBotQueuesNPS:
            "Cantidad máxima de veces que la evaluación será enviada",
          closeLastMessageOptions1: "Del Agente/Cliente",
          closeLastMessageOptions2: "Del Agente",
          outOfHoursMessage: "Mensaje fuera de horario de atención",
          greetingMessage: "Mensaje de saludo",
          complationMessage: "Mensaje de conclusión",
          lgpdLinkPrivacy: "Link para políticas de privacidad",
          lgpdMessage: "Mensaje inicial de LPD",
          lgpdDeletedMessages: "Ofuscar mensaje borrada por el contacto",
          lgpdSendMessage: "Siempre solicitar confirmación del contacto",
          ratingMessage: "Mensaje de evaluación - Rango de 0 a 10",
          token: "Token para integración externa",
          sendIdQueue: "Fila",
          inactiveMessage: "Mensaje de inactividad",
          timeInactiveMessage:
            "Tiempo em minutos para el envío del aviso de inactividad",
          whenExpiresTicket:
            "Cerrar chats abiertos cuando el último mensaje sea",
          expiresInactiveMessage: "Mensaje al cerrar por inactividad",
          prompt: "Prompt",
          collectiveVacationEnd: "Fecha final",
          collectiveVacationStart: "Fecha inicial",
          collectiveVacationMessage: "Mensaje de vacaciones colectivas",
          queueIdImportMessages: "Fila para importar los mensajes",
          isOficial: "Oficial",
          phone_number_id: "ID Número de teléfono",
          waba_id: "Waba ID",
          send_token: "Token de envío",
          business_id: "ID del negocio",
          phone_number: "Número de teléfono",
          flowInactiveTime: "Tiempo en minutos para envío del flujo de inactividad",
          triggerIntegrationOnClose:
            "Disparar Integración al Cerrar Ticket",
          enableIntegration: "Habilitar Integración",
          errorRatingMessage:
            "Es obligatorio informar un mensaje de evaluación cuando se utiliza el NPS.",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        menuItem: {
          enabled: "Activado",
          disabled: "Desactivado",
          minutes: "minutos",
        },
        success: "WhatsApp guardado satisfactoriamente.",
        errorSendQueue:
          "Además del tiempo debes seleccinar una fila para redirecionar. Se necesitan los dos campos.",
        errorExpiresNPS:
          "Es necesario llenar el tiempo para la evaluación para el NPS.",
      },
      qrCode: {
        message: "Lée el código QR para empezar la sesión.",
      },
      contacts: {
        title: "Contactos",
        toasts: {
          deleted: "¡Contacto borrado satisfactoriamente!",
        },
        searchPlaceholder: "Buscar...",
        loading: "Cargando...",
        loadMore: "Cargar Más",
        conversationFlows: "Flujos de Conversación",
        addFlow: "Agregar Flujo",
        editFlow: "Editar Flujo ",
        confirmationModal: {
          deleteTitle: "Borrar",
          importTitlte: "Importar contactos",
          exportContact: "Exportar contactos",
          deleteMessage:
            "¿Estás seguro que deseas borrar este contacto? Todos los tickets relacionados se perderán.",
          blockContact: "¿Estás seguro que quieres bloquear este contacto?",
          unblockContact:
            "¿Estás seguro que quieres desbloquear este contacto?",
          importMessage: "¿Quieres importar todos los contactos del teléfono?",
          importChat: "Importar Conversaciones",
          wantImport:
            "¿Quieres importar todas las conversaciones del teléfono?",
        },
        buttons: {
          import: "Importar Contactos",
          add: "Agregar Contacto",
          export: "Exportar Contacto",
        },
        table: {
          name: "Nombre",
          whatsapp: "WhatsApp",
          email: "Correo Electrónico",
          actions: "Acciones",
          lastMessage: "Último Mensaje",
          wallet: "Cartera",
        },
        menu: {
          importYourPhone: "Importar del celular por default",
          importToExcel: "Importar / Exportar del Excel",
          importexport: "IMPORTAR / EXPORTAR",
        },
      },
      forwardMessage: {
        text: "Reenviada",
      },
      forwardMessageModal: {
        title: "Reenviar mensaje",
        buttons: {
          ok: "Reenviar",
        },
      },
      promptModal: {
        form: {
          name: "Nombre",
          prompt: "Prompt",
          voice: "Voz",
          max_tokens: "Máximo de Tokens en la respuesta",
          temperature: "Temperatura",
          apikey: "API Key",
          max_messages: "Máximo de mensajes del Historico",
          voiceKey: "Llave de la API de la Voz",
          voiceRegion: "Región de la Voz",
        },
        success: "Prompt guardado",
        title: {
          add: "Agregar Prompt",
          edit: "Editar Prompt",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Nombre",
          queue: "Sector/Fila",
          max_tokens: "Máximo Tokens Respuestas",
          actions: "Acciones",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "¿Estás seguro? ¡Esta acción no se puede revertir!",
        },
        buttons: {
          add: "Agregar Prompt",
        },
      },
      contactModal: {
        title: {
          add: "Agregar contacto",
          edit: "Editar contacto",
        },
        form: {
          mainInfo: "Detalles del contacto",
          extraInfo: "Información adicional",
          name: "Nombre",
          number: "Número de Whatsapp",
          email: "Correo Electrónico",
          extraName: "Nombre del Campo",
          extraValue: "Valor",
          chatBotContact: "Desactivar chatbot para este contacto",
          termsLGDP: "Términos P.P. aceptados en:",
          allTicket: "Visualizar tickets sin fila",
          allowGroup: "Permitir grupos",
        },
        buttons: {
          addExtraInfo: "Agregar información",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Contacto guardado satisfactoriamente.",
        walletLinked: "¡Contacto vinculado a su billetera exitosamente!",
        walletError: "El usuario no tiene colas asociadas",
        saveFirst: "El contacto debe guardarse primero",
      },
      wallets: {
        title: "Billeteras de Contactos",
        searchPlaceholder: "Buscar contactos...",
        filterByUser: "Filtrar por Usuario",
        allUsers: "Todos los usuarios",
        contact: "Contacto",
        user: "Usuario",
        queue: "Cola",
        phone: "Teléfono",
        email: "Email",
        actions: "Acciones",
        editWallet: "Editar Billetera",
        selectUser: "Seleccionar Usuario",
        selectQueue: "Seleccionar Cola",
        selectUserAndQueue: "Seleccione un usuario y una cola",
        cancel: "Cancelar",
        save: "Guardar",
        confirmDeleteTitle: "Confirmar Eliminación",
        confirmDeleteMessage:
          "¿Está seguro de que desea eliminar este contacto de la billetera?",
        deleteSuccess: "¡Contacto eliminado de la billetera exitosamente!",
        updateSuccess: "¡Billetera actualizada exitosamente!",
      },
      queueModal: {
        title: {
          queueData: "Datos de la fila",
          text: "Horarios de atención",
          add: "Agregar fila",
          edit: "Editar fila",
          confirmationDelete:
            "¿Está seguro? Todas las opciones integradas también se eliminarán.",
        },
        form: {
          name: "Nombre",
          color: "Color",
          orderQueue: "Orden de la fila (Bot)",
          rotate: "Rotativo",
          timeRotate: "Tiempo de Rotación",
          typeRandomMode: "Tipo de rotación",
          randomizeImmediate: "Aleatorizar Automáticamente (Inmediato)",
          greetingMessage: "Mensaje de saludo",
          complationMessage: "Mensaje de cierre",
          outOfHoursMessage: "Mensaje fuera de horario de atención",
          token: "Token",
          integrationId: "Integración",
          fileListId: "Listado de archivos",
          closeTicket: "Cerrar ticket",
          queueType: "Tipo de menu",
          message: "Mensaje de respuesta",
          queue: "Fila para transferencia",
          integration: "Integración",
          file: "Listado de archivos",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Editar",
          cancel: "Cancelar",
        },
        bot: {
          title: "Opciones",
          toolTipTitle: "Agregue las opciones para construir un chatbot",
          toolTip:
            "Si solo hay una opción, se elegirá automáticamente, lo que hará que el bot responda con el mensaje de la opción y avance.",
          selectOption: "Seleccione una opción",
          text: "Texto",
          attendent: "Agente",
          queue: "Fila",
          integration: "Integranción",
          file: "Archivo",
          toolTipMessageTitle:
            "El mensaje es obligatorio para pasar al siguiente nivel",
          toolTipMessageContent:
            "El mensaje es obligatorio para pasar al siguiente nivel",
          selectUser: "Seleccione un Usuario",
          selectQueue: "Seleccione una Fila",
          selectIntegration: "Seleccione um Integración",
          addOptions: "Agregar opciones",
        },
        serviceHours: {
          dayWeek: "Día",
          startTimeA: "Hora de Inicio",
          endTimeA: "Hora del término",
          startTimeB: "Hora de Inicio",
          endTimeB: "Hora del término",
          monday: "Lunes",
          tuesday: "Martes",
          wednesday: "Miércoles",
          thursday: "Jueves",
          friday: "Viernes",
          saturday: "Sabado",
          sunday: "Domingo",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Agregar proyecto",
          edit: "Editar proyecto",
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Idioma",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tiempo en minutos para expirar una conversación",
          typebotKeywordFinish: "Palabra para finalizar la conversación",
          typebotKeywordRestart: "Palabra para reiniciar el flujo",
          typebotRestartMessage: "Mensaje al reiniciar la conversación",
          typebotUnknownMessage: "Mensaje de opción inválida",
          typebotDelayMessage: "Intervalo (ms) entre mensajes",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          test: "Probar Bot",
        },
        messages: {
          testSuccess: "¡Integración testada con éxito!",
          addSuccess: "¡Integración agregada con éxito!",
          editSuccess: "¡Integración editada con éxito!",
        },
      },
      userModal: {
        warning:
          "Para importar los mensajes por favor vuelva a leer el QRCode.",
        title: {
          add: "Agregar usuario",
          edit: "Editar usuario",
          updateImage: "Actualizar Imagen",
          removeImage: "Excluir Imagen",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          farewellMessage: "Mensaje de despedida",
          profile: "Perfil",
          startWork: "Inicio del Horario",
          endWork: "Final del Horario",
          whatsapp: "Conexión Defautl",
          allTicketEnable: "Activado",
          allTicketDisable: "Desactivado",
          allTicket: "Visualizar mensajes sin fila",
          allowGroup: "Permitir Grupos",
          defaultMenuOpen: "Abierto",
          defaultMenuClosed: "Cerrado",
          defaultMenu: "Menu Estándar",
          defaultTheme: "Tema Estándar",
          defaultThemeDark: "Oscuro",
          defaultThemeLight: "Claro",
          allHistoric: "Ver historicos",
          allHistoricEnabled: "Activado",
          allHistoricDisabled: "Desactivado",
          allUserChat: "Ver conversación de otros usuarios",
          userClosePendingTicket: "Permitir cerrar tickets pendientes",
          allowSeeMessagesInPendingTickets: "Permitir ver tickets pendientes",
          showDashboard: "Ver Dashboard",
          allowRealTime: "Ver Panel de Atención",
          allowConnections: "Permitir acciones en conexiones",
          showContacts: "Ver contactos",
          showCampaign: "Ver campañas",
          showFlow: "Ver automatizaciones",
        },
        tabs: {
          general: "General",
          permissions: "Permissos",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          addImage: "Agregar Imagen",
          editImage: "Editar Imagen",
        },
        success: "Usuario guardado satisfactoriamente.",
      },
      companyModal: {
        title: {
          add: "Agregar empresa",
          edit: "Editar empresa",
        },
        form: {
          name: "Nombre",
          email: "Correo electrónico",
          passwordDefault: "Contraseña",
          numberAttendants: "Usuarios",
          numberConections: "Conexiones",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "La Empresa fue guardada satisfactoriamente.",
      },
      scheduleModal: {
        title: {
          add: "Nuevo Agendamiento",
          edit: "Editar Agendamiento",
          message: "Mensaje",
        },
        form: {
          body: "Mensaje",
          contact: "Contacto",
          sendAt: "Fecha del Programa",
          sentAt: "Fecha de Envío",
          scheduledDate: "Fecha del Programa",
          assinar: "Enviar Firma",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
          next: "Siguiente",
          addSchedule: "Agregar programa",
        },
        steps: {
          recipient: "Destinatario",
          recipientDesc: "Seleccione el contacto y fecha",
          message: "Mensaje",
          messageDesc: "Configure el mensaje",
          settings: "Configuraciones",
          settingsDesc: "Ajustes finales",
        },
        recipientTitle: "Destinatario y Agendamiento",
        recipientSubtitle: "Seleccione el contacto y defina cuándo se enviará el mensaje",
        contactPlaceholder: "Seleccione un contacto",
        contactLabel: "👤 Contacto",
        dateLabel: "📅 Fecha y Hora de Envío",
        success: "Programa guardado satisfactoriamente.",
      },
      tagModal: {
        title: {
          add: "Nueva Tag",
          edit: "Editar Tag",
          addKanban: "Nueva Lane",
          backToKanban: "VOLVER A KANBAN",
          editKanban: "Editar Lane",
        },
        form: {
          name: "Nombre",
          color: "Color",
          timeLane: "Tiempo en minutos para redirigir a la lane",
          nextLaneId: "Lane",
          greetingMessageLane: "Mensaje de saludo de la lane",
          mediaFiles: "Multimedia",
          rollbackLaneId: "Volver a Lane al retomar atención",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Tag guardada satisfactoriamente.",
        successKanban: "Lane guardada satisfactoriamente.",
      },
      fileModal: {
        title: {
          add: "Agregar lista de archivos",
          edit: "Editar lista de archivos",
        },
        buttons: {
          okAdd: "Guardar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Agregar archivo",
        },
        form: {
          name: "Nombre de la lista de archivos",
          message: "Detalles de la lista",
          fileOptions: "Lista de archivos",
          extraName: "Mensaje para enviar con archivo",
          extraValue: "Valor de la opción",
        },
        success: "Evaluación guardada satisfactoriamente.",
      },
      chat: {
        noTicketMessage: "Selecciona un ticket para empezar a chatear.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop:
            "⬇️ ARRASTRE Y SUELTE LOS ARCHIVOS EN EL CAMPO ⬇️",
          titleFileList: "Listado de archivo(s)",
        },
      },
      chatInternal: {
        new: "Crear grupo",
        modal: {
          conversation: "Conversación",
          title: "Nombre",
          filterUsers: "Seleccionar integrantes",
          cancel: "Cerrar",
          save: "Guardar",
        },
        modalDelete: {
          title: "Eliminar Conversación",
          message: "Esta acción no se puede revertir, ¿confirmar?",
        },
      },
      ticketsManager: {
        questionCloseTicket: "¿DESEAS CERRAR TODOS LOS TICKETS?",
        yes: "SÍ",
        not: "NO",
        buttons: {
          newTicket: "Nuevo",
          resolveAll: "Resolver Todos",
          close: "Cerrar",
          new: "Nuevo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
      },
      tickets: {
        messageHidden: "Mensaje oculto",
        inbox: {
          closedAllTickets: "¿Cerrar todos los tickets?",
          closedAll: "Cerrar Todos",
          newTicket: "Nuevo Ticket",
          yes: "SÍ",
          no: "NO",
          open: "Abiertos",
          resolverd: "Resueltos",
        },
        toasts: {
          deleted: "El ticket en el que estabas ha sido borrado.",
        },
        notification: {
          message: "Mensaje de",
        },
        tabs: {
          open: { title: "Bandeja" },
          closed: { title: "Resueltos" },
          search: { title: "Buscar" },
        },
        search: {
          placeholder: "Buscar tickets y mensajes.",
          filterConections: "Filtro por Conexión",
          filterConectionsOptions: {
            open: "Abierto",
            closed: "Cerrado",
            pending: "Pendiente",
          },
          filterUsers: "Filtro por usuarios",
          filterContacts: "Filtrar por Contactos",
          hasMedia: "Con multimedia",
          fetchError: "Error al obtener datos del reporte",
          ticketsPerPage: "Entradas por página",
        },
        buttons: {
          showAll: "Todos",
          returnQueue: "Regresar a la Fila",
          scredule: "Programar",
          deleteTicket: "Borrar Ticket",
        },
        closedTicket: {
          closedMessage: "Cerrar CON un mensaje de despedida",
          closedNotMessage: "Cerrar SIN un mensaje de despedida",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Escriba para buscar usuarios",
        fieldQueueLabel: "Transferir para fila",
        fieldQueuePlaceholder: "Seleccione una fila",
        fieldWhatsapp: "Seleccione un whatsapp",
        noOptions: "No se encontraron usuarios con ese nombre",
        msgTransfer:
          "Observación - los mensajes internos, no serán visualizados por el cliente.",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        called: "Entradas",
        today: "Hoy",
        missedCall: "Llamada de voz/vídeo perdida a las",
        pendingHeader: "Esperando",
        assignedHeader: "Trabajando en",
        groupingHeader: "Grupos",
        noTicketsTitle: "¡Nada acá!",
        noTicketsMessage:
          "No se encontraron tickets con este estado o término de búsqueda",
        noQueue: "Sin Fila",
        buttons: {
          accept: "Aceptar",
          cancel: "Cancelar",
          start: "Iniciar",
          closed: "Cerrar",
          reopen: "Reabrir",
          transfer: "Transferir",
          ignore: "Ignorar",
          exportAsPDF: "Exportar para PDF",
        },
        acceptModal: {
          title: "Aceptar Chat",
          queue: "Seleccionar tag",
        },
      },
      newTicketModal: {
        title: "Crear Ticket",
        fieldLabel: "Escribe para buscar un contacto",
        add: "Agregar",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar",
        },
      },
      triggerFlowModal: {
        title: "Disparar Flujo",
        description: "Seleccione el flujo que desea disparar para este contacto",
        buttons: {
          ok: "Disparar",
          cancel: "Cancelar",
        },
        success: "¡Flujo disparado con éxito!",
        error: "Error al disparar el flujo",
        selectFlow: "Seleccionar Flujo",
        noFlows: "No hay flujos disponibles",
      },
      contactList: {
        dialog: "¡Lista de contactos guardada con éxito!",
      },
      SendContactModal: {
        title: "Enviar contacto",
        fieldLabel: "Buscar contacto",
        add: "Agregar",
        buttons: {
          ok: "Enviar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexiones",
          chatsTempoReal: "Panel de Asistencia",
          tickets: "Inbox",
          quickMessages: "Respuestas Rápidas",
          contacts: "Contactos",
          wallets: "Billeteras",
          queues: "Filas",
          tags: "Tags",
          administration: "Administración",
          companies: "Empresas",
          users: "Usuarios",
          settings: "Configuración",
          ratings: "Regist. Evaluaciones",
          helps: "Ayuda",
          messagesAPI: "API",
          schedules: "Programa",
          campaigns: "Campañas",
          annoucements: "Informativos",
          chats: "Chat Interno",
          financeiro: "Financiero",
          queueIntegration: "Integraciones",
          version: "Versión",
          kanban: "Kanban",
          prompts: "Talk.Ai",
          allConnections: "Admin conexiones",
          automations: "Automatizaciones",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Cerrar Sesión",
            message: "Hola",
            messageEnd: "bienvenido a",
            active: "Activo hasta",
            goodMorning: "Hola,",
            myName: "mi nombre es",
            continuity: "y te seguiré apoyando.",
            virtualAssistant: "Asistente Virtual",
            token:
              "Token inválido, favor comunicarse con el administrador de la plataforma.",
          },
          message: {
            location: "Localización",
            contact: "Contacto",
          },
          notRegister: "No hay registros",
          refresh: "Atuaclizar",
        },
      },
      languages: {
        undefined: "Idioma",
        "es-Mx": "Español",
        es: "Español",
        en: "English",
        tr: "Türkçe",
      },
      messagesAPI: {
        title: "API",
        toSend: "ENVIAR",
        textMessage: {
          number: "Número",
          body: "Mensaje",
          token: "Token registrado",
          userId: "ID usuario/agente",
          queueId: "ID Fila",
        },
        mediaMessage: {
          number: "Número",
          body: "Nombre del archivo",
          media: "Archivo",
          token: "Token registrado",
        },
        API: {
          title: "Documentación para envío de mensajes",
          methods: {
            title: "Métodos de Envío",
            messagesText: "Mensajes de Texto",
            messagesMidia: "Mensajes de Midia",
          },
          instructions: {
            title: "Instrucciones",
            comments: "Observaciones Importantes",
            comments1:
              "Antes de enviar mensajes, es necesario registrar el token vinculado a la conexión que enviará los mensajes. <br />Para registrarse, acceda al menú 'Conexiones', haga clic en el botón de edición de la conexión e inserte el token en el campo correspondiente.",
            comments2:
              "El número de envío no debe tener máscara ni caracteres especiales y debe constar de:",
            codeCountry: "Código del País",
            code: "Código del Estado",
            number: "Numero",
          },
          text: {
            title: "1. Mensajes de Texto",
            instructions:
              "A continuación se muestra la lista de información necesaria para enviar mensajes de texto:",
          },
          media: {
            title: "2. Mensagens de Media",
            instructions:
              "A continuación se muestra la lista de información necesaria para enviar mensajes con archivos:",
          },
        },
      },
      notifications: {
        noTickets: "Sin notificaciones.",
      },
      quickMessages: {
        title: "Respuestas Rápidas",
        searchPlaceholder: "Buscar...",
        noAttachment: "Sin adjunto",
        noQuickMessages: "No hay respuestas rápidas disponibles",
        noResultsFound: "No se encontraron respuestas rápidas para tu búsqueda",
        selectMessage: "Seleccionar Respuesta Rápida",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir. ¿Continuar?",
        },
        buttons: {
          add: "Agregar",
          attach: "Adjuntar Archivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "Atajo agregado satisfactoriamente.",
          deleted: "Atajo excluido satisfactoriamente.",
        },
        dialog: {
          title: "Mensaje Rápido",
          shortcode: "Atajo",
          message: "Respuesta",
          save: "Guardar",
          cancel: "Cancelar",
          general: "General",
          geral: "Global",
          global: "Global",
          public: "Público",
          add: "Agregar",
          edit: "Editar",
          visao: "Permitir visión",
        },
        table: {
          shortcode: "Atajo",
          message: "Mensaje",
          actions: "Acciones",
          mediaName: "Nombre del Archivo",
          status: "Status",
        },
      },
      contactLists: {
        title: "Listado de Contactos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acciones",
        },
        buttons: {
          add: "Nuevo Listado",
        },
        dialog: {
          name: "Nombre",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },
      contactListItems: {
        title: "Contactos",
        searchPlaceholder: "Búsqueda",
        buttons: {
          add: "Nuevo",
          lists: "Listados",
          import: "Importar",
        },
        dialog: {
          name: "Nombre",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "Correo electrónico",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        table: {
          name: "Nombre",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "Correo electrónico",
          actions: "Acciones",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
          importMessage: "¿Quieres importar esta plantilla? ",
          importTitlte: "Importar",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },
      kanban: {
        title: "Kanban",
        searchPlaceholder: "Búsqueda",
        noFlows: "No se encontraron flujos activos",
        selectedFlow: "Flujo seleccionado",
        selectFlow: "Elegir un flujo",
        trigger: "Disparar Flujo",
        triggerFlow: "Disparar Flujo",
        triggering: "Disparando...",
        flowId: "ID del flujo",
        kanbanActions: "Opciones de Kanban",
        subMenus: {
          list: "Panel",
          tags: "Lanes",
        },
      },
      templates: {
        title: "Templates de Campañas",
        useTemplate: "Usar Template",
        createFromScratch: "Crear desde Cero",
        noPermission: "Esta empresa no tiene permiso para acceder a esta página. Lo estamos redirigiendo.",
        permissionError: "Error al verificar permisos. Redirigiendo...",
        humanized: {
          title: "Humanizado",
          description: "Disparo con comportamiento natural y humano",
          features: {
            f1: "Delays aleatorios entre mensajes",
            f2: "Variación de tiempo de respuesta",
            f3: "Comportamiento más natural",
            api: "API Baileys",
            contacts: "Hasta 40 contactos",
          },
        },
        bot: {
          title: "Bot",
          description: "Disparo automático con configuraciones estándar",
          features: {
            f1: "Ejecución rápida y eficiente",
            f2: "Configuraciones optimizadas",
            f3: "Ideal para campañas masivas",
            api: "API Baileys",
            contacts: "Hasta 70 contactos",
          },
        },
        forced: {
          title: "Forzado",
          description: "Disparo inmediato sin delays",
          features: {
            f1: "Ejecución instantánea",
            f2: "Sin delays entre mensajes",
            f3: "Máxima velocidad",
            api: "API Baileys",
            contacts: "Hasta 110 contactos",
          },
        },
        speed: {
          title: "Velocidad",
          description: "Disparo optimizado para máximo rendimiento",
          features: {
            f1: "Procesamiento paralelo",
            f2: "Optimización de recursos",
            f3: "Mejor throughput",
            api: "API Unizap",
            contacts: "Hasta 200 contactos",
          },
        },
        growth: {
          title: "Crecimiento",
          description: "Disparo progresivo con escalabilidad",
          features: {
            f1: "Aumento gradual de volumen",
            f2: "Monitoreo continuo",
            f3: "Ajuste automático",
            api: "API NotificameHub",
            contacts: "Ilimitado (con costo)",
          },
        },
        security: {
          title: "Seguridad",
          description: "Disparo con validaciones y protecciones",
          features: {
            f1: "Validación de contactos",
            f2: "Protección contra bloqueos",
            f3: "Monitoreo de errores",
            api: "API WABA",
            contacts: "Ilimitado (con costo)",
          },
        },
        custom: {
          title: "Personalizado",
          description: "Cree su campaña desde cero con total libertad",
          features: {
            f1: "Configuración personalizada",
            f2: "Elija su API",
            f3: "Defina sus propios límites",
            api: "Todas las APIs",
            contacts: "Sin restricciones",
          },
        },
      },
      campaigns: {
        title: "Campañas de Disparo",
        searchPlaceholder: "Búsqueda",
        templatesButton: "📋 Templates",
        newCampaign: "➕ Nueva Campaña",
        searchFilters: "🔍 Filtros de Búsqueda",
        searchCampaign: "Buscar Campaña",
        searchCampaignPlaceholder: "Escriba el nombre de la campaña...",
        filterByStatus: "Filtrar por Status",
        filterByRecurrence: "Filtrar por Recurrencia",
        all: "Todos",
        allFemale: "Todas",
        recurring: "Recurrentes",
        single: "Únicas",
        totalCampaigns: "Total de Campañas",
        active: "Activas",
        scheduled: "Programadas",
        recurrent: "Recurrentes",
        noCampaignsFound: "Ninguna campaña encontrada",
        totalLabel: "Total: {count} campañas",
        rowsPerPage: "Líneas por página:",
        stopRecurrenceTitle: "Interrumpir Recurrencia",
        stopRecurrenceMessage: "¿Está seguro de que desea interrumpir la recurrencia de esta campaña? La campaña actual continuará ejecutándose, pero no habrá más ejecuciones futuras.",
        stopRecurrenceSuccess: "¡Recurrencia interrumpida con éxito!",
        noPermission: "Esta empresa no tiene permiso para acceder a esta página. Lo estamos redirigiendo.",
        status: {
          inactive: "Inactiva",
          scheduled: "Programada",
          inProgress: "En Progreso",
          cancelled: "Cancelada",
          finished: "Finalizada",
        },
        recurrenceTypes: {
          minutely: "Por Minuto",
          hourly: "Por Hora",
          daily: "Diario",
          weekly: "Semanal",
          biweekly: "Quincenal",
          monthly: "Mensual",
          yearly: "Anual",
          single: "Única",
          executions: "ejecuciones",
        },
        tableHeaders: {
          name: "Nombre",
          status: "Status",
          recurrence: "Recurrencia",
          listTag: "Lista/Tag",
          whatsapp: "WhatsApp",
          scheduling: "Agendamiento",
          nextExecution: "Próxima Ejecución",
          conclusion: "Conclusión",
          confirmation: "Confirmación",
          actions: "Acciones",
        },
        tableData: {
          recurringCampaign: "Campaña Recurrente",
          listRemoved: "Lista eliminada",
          tagPrefix: "Tag:",
          notDefined: "No definida",
          whatsappRemoved: "WhatsApp eliminado",
          notDefinedMasc: "No definido",
          noSchedule: "Sin agendamiento",
          finished: "Finalizada",
          notCompleted: "No concluida",
          yes: "✓ Sí",
          no: "✗ No",
        },
        tooltips: {
          stopCampaign: "Detener Campaña",
          restartCampaign: "Reiniciar Campaña",
          stopRecurrence: "Interrumpir Recurrencia",
          report: "Reporte",
          edit: "Editar",
          delete: "Eliminar",
        },
        subMenus: {
          list: "Listados",
          listContacts: "Listados de contactos",
          settings: "Configuraciones",
        },
        settings: {
          randomInterval: "Intervalo de disparo aleatorio",
          noBreak: "Sin Intervalo",
          intervalGapAfter: "Intervalo mayor después de",
          undefined: "No definido",
          messages: "mensajes",
          laggerTriggerRange: "Intervalo de envío más grande",
          addVar: "Agregar variable",
          save: "Guardar",
          close: "Cerrar",
          add: "Agregar",
          shortcut: "Atajo",
          content: "Contenido",
        },
        buttons: {
          add: "Nueva Campaña",
          contactLists: "Listado de Contactos",
        },
        table: {
          name: "Nombre",
          whatsapp: "Conexión",
          contactList: "Listado de Contactos",
          option: "Ninguna",
          disabled: "Activada",
          enabled: "Desactivada",
          status: "Status",
          scheduledAt: "Programa",
          completedAt: "Finalizada",
          confirmation: "Confirmación",
          actions: "Acciones",
        },
        dialog: {
          new: "Nueva Campaña",
          update: "Editar Campaña",
          readonly: "Solo Visualizar",
          help: "Use variables como {nombre}, {numero}, {email} o defina variables personalizadas.",
          form: {
            name: "Nombre",
            message1: "Mensaje 1",
            message2: "Mensaje 2",
            message3: "Mensaje 3",
            message4: "Mensaje 4",
            message5: "Mensaje 5",
            confirmationMessage1: "Mensaje de Confirmación 1",
            confirmationMessage2: "Mensaje de Confirmación 2",
            confirmationMessage3: "Mensaje de Confirmación 3",
            confirmationMessage4: "Mensaje de Confirmación 4",
            confirmationMessage5: "Mensaje de Confirmación 5",
            messagePlaceholder: "Contenido del Mensaje",
            whatsapp: "Conexión",
            status: "Status",
            scheduledAt: "Programa",
            scheduledDate: "Fecha del Programa",
            confirmation: "Confirmación",
            contactList: "Listado de Contacto",
            tagList: "Tags",
            statusTicket: "Status del Ticket",
            openTicketStatus: "Abierto",
            closedTicketStatus: "Cerrado",
            pendingTicketStatus: "Pendiente",
            transferredTicketStatus: "Transferido",
            enabledOpenTicket: "Activado",
            disabledOpenTicket: "Desactivado",
            openTicket: "Abrir ticket",
            template: "Template Meta",
            newCampaignWithFlowByPhrase: "Nueva campaña con flujo por frase",
            editCampaignWithFlowByPhrase: "Editar campaña con flujo por frase",
            phraseTriggerName: "Nombre del disparador por frase",
            whichPhraseTriggersTheFlow: "¿Qué frase dispara el flujo?",
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar Envíos",
            restart: "Reiniciar Envíos",
            close: "Cerrar",
            attach: "Anexar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        toasts: {
          success: "Acción realizada satisfactoriamente",
          cancel: "Campaña cancelada",
          restart: "Campaña reiniciada",
          deleted: "Registro excluido",
        },
      },
      campaignReport: {
        title: "Reporte de",
        inactive: "Inactiva",
        scheduled: "Programada",
        process: "En Proceso",
        cancelled: "Cancelada",
        finished: "Finalizada",
        campaign: "Campaña",
        validContacts: "Contactos Válidos",
        confirmationsRequested: "Confirmaciones Solicitadas",
        confirmations: "Confirmaciones",
        deliver: "Entregadas",
        connection: "Conexión",
        contactLists: "Listado de Contactos",
        schedule: "Programados",
        conclusion: "Conclusión",
      },
      announcements: {
        title: "Boletines",
        searchPlaceholder: "Búsqueda",
        active: "Activo",
        inactive: "Inactivo",
        buttons: {
          add: "Nuevo Boletin",
          contactLists: "Listados de Boletines",
        },
        table: {
          priority: "Prioridad",
          title: "Título",
          text: "Texto",
          mediaName: "Archivo",
          status: "Status",
          actions: "Acciones",
        },
        dialog: {
          edit: "Editar Boletin",
          add: "Nuevo Boletin",
          update: "Editar Boletin",
          readonly: "Solo visualizar",
          form: {
            priority: "Prioridad",
            title: "Título",
            text: "Texto",
            mediaPath: "Archivo",
            status: "Status",
            high: "Alta",
            medium: "Mediana",
            low: "Baja",
            active: "Activo",
            inactive: "Inactivo",
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Cerrar",
            attach: "Anexar Archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        toasts: {
          success: "Acción realizada satisfactoriamente",
          deleted: "Registro excluido",
        },
      },
      queues: {
        title: "Filas",
        table: {
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de saludo",
          orderQueue: "Orden de la fila (bot)",
          actions: "Acciones",
          ID: "ID",
        },
        buttons: {
          add: "Agregar fila",
        },
        toasts: {
          success: "Fila guardada",
          deleted: "Fila excluida",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede revertir! Los tickets en esa fila seguirán existiendo, pero ya no tendrán ninguna fila asignada.",
        },
      },
      queue: {
        queueData: "Datos",
      },
      queueSelect: {
        inputLabel: "Filas",
        inputLabelRO: "Filas solo para lectura",
        withoutQueue: "Sin cola",
      },
      reports: {
        title: "Reportes de Atenciones",
        startDate: "Fecha Inicial",
        endDate: "Fecha Final",
        table: {
          id: "Ticket",
          user: "Usuario",
          dateOpen: "Fecha Apertura",
          dateClose: "Fecha Cierre",
          NPS: "NPS",
          status: "Estado",
          whatsapp: "Conexión",
          queue: "Fila",
          actions: "Acciones",
          lastMessage: "Últ. Mensaje",
          contact: "Cliente",
          supportTime: "Tiempo de Atención",
        },
        buttons: {
          filter: "Aplicar Filtro",
          onlyRated: "Solo Evaluados",
        },
        searchPlaceholder: "Buscar...",
        filters: {
          searchContact: "Buscar Contacto",
          connections: "Conexiones",
          status: "Estado",
          users: "Usuarios",
          queues: "Filas",
          initialDate: "Fecha Inicial",
          finalDate: "Fecha Final",
          onlyRated: "Solo Evaluados",
          clearFilters: "Limpiar Filtros",
          filter: "Filtrar",
          export: "Exportar",
        },
        tabs: {
          overview: "Visión General",
          details: "Detalles",
          profanity: "Monitor IA",
        },
        stats: {
          totalTickets: "Total de Tickets",
          open: "Abiertos",
          closed: "Cerrados",
          pending: "Pendientes",
          rated: "Evaluados",
          unrated: "No Evaluados",
        },
        charts: {
          ratings: "Evaluaciones",
        },
        messages: {
          noTicketsFound: "Ningún ticket encontrado",
          loading: "Cargando...",
          filtering: "Filtrando...",
          noDataToDisplay: "Sin datos para mostrar",
        },
      },
      queueIntegration: {
        title: "Integraciones",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nombre",
          projectName: "Nombre del Proyecto",
          language: "Idioma",
          lastUpdate: "Ultima actualización",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar Proyecto",
        },
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "¿Estás seguro? ¡Esta acción no se puede revertir! Se eliminarán las filas y conexiones enlazadas",
        },
      },
      users: {
        title: "Usuarios",
        table: {
          status: "Status",
          name: "Nombre",
          email: "Correo Electrónico",
          profile: "Perfil",
          startWork: "Inicio del trabajo",
          endWork: "Final de trabajo",
          actions: "Acciones",
          ID: "ID",
        },
        buttons: {
          add: "Agregar usuario",
        },
        toasts: {
          deleted: "Usuario borrado satisfactoriamente.",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteMessage:
            "Toda la información del usuario se perderá. Los tickets abiertos de los usuarios se moverán a la fila.",
        },
      },
      compaies: {
        title: "Empresas",
        table: {
          ID: "ID",
          status: "Activo",
          name: "Nombre",
          email: "Correo",
          password: "Contraseña",
          phone: "Teléfono",
          plan: "Plan",
          active: "Activo",
          numberAttendants: "Agentes",
          numberConections: "Conexiones",
          value: "Valor",
          namePlan: "Nombre del Plan",
          numberQueues: "Filas",
          useCampaigns: "Campañas",
          useExternalApi: "Rest API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "Whatsapp",
          useInternalChat: "Chat Interno",
          useSchedules: "Programa",
          createdAt: "F.Creación",
          dueDate: "Caducidad",
          lastLogin: "Ult. Login",
          folderSize: " Tamaño de carpeta ",
          totalFiles: "  Archivos totales",
          lastUpdate: "Última actualización",
          actions: "Acciones",
          money: "MXN",
          yes: "Si",
          no: "No",
          document: "CURP/RFC",
          recurrence: "Recurencia",
          monthly: "Mensual",
          bimonthly: "Bimestral",
          quarterly: "Trimestral",
          semester: "Semestral",
          yearly: "Anual",
          clear: "Limpiar",
          delete: "Eliminar",
          user: "Usuario",
          save: "Guardar",
        },
        buttons: {
          add: "Agregar empresa",
        },
        toasts: {
          deleted: "Empresa excluida satisfactoriamente.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todas las informaciones de la empresa serán eliminadas. Los tickets abiertos de este usuário serán movidos a la fila.",
        },
      },
      plans: {
        form: {
          name: "Nombre",
          users: "Usuarios",
          connections: "Conexiones",
          campaigns: "Campañas",
          schedules: "Programas",
          enabled: "Activada",
          disabled: "Desactivada",
          clear: "Limpiar",
          delete: "Eliminar",
          save: "Guardar",
          yes: "Si",
          no: "No",
          money: "MXN",
        },
      },
      helps: {
        title: "Ayuda",
        settings: {
          codeVideo: "Código del Video",
          description: "Descripción",
          clear: "Limpiar",
          delete: "Eliminar",
          save: "Guardar",
        },
      },
      schedules: {
        title: "Agendamientos",
        date: "Fecha",
        time: "Hora",
        event: "Evento",
        allDay: "Todo el Día",
        week: "Semana",
        work_week: "Programaciones",
        day: "Día",
        month: "Mes",
        previous: "Anterior",
        next: "Siguiente",
        yesterday: "Ayer",
        tomorrow: "Mañana",
        today: "Hoy",
        agenda: "Agenda",
        noEventsInRange: "No hay eventos en este período.",
        deleteTitle: "Eliminar Agendamiento",
        deleteConfirmNamed: "¿Está seguro de que desea eliminar el agendamiento para \"{name}\"? Esta acción no se puede revertir.",
        deleteConfirm: "¿Está seguro de que desea eliminar este agendamiento? Esta acción no se puede revertir.",
        deleteSuccess: "🗑️ ¡Agendamiento eliminado con éxito!",
        confirmDelete: "Sí, Eliminar",
        cancel: "Cancelar",
        edit: "Editar",
        delete: "Eliminar",
        noPermission: "⚠️ Esta empresa no tiene permiso para acceder a esta página. Lo estamos redirigiendo.",
        dayNames: {
          sunday: "Domingo",
          monday: "Lunes",
          tuesday: "Martes",
          wednesday: "Miércoles",
          thursday: "Jueves",
          friday: "Viernes",
          saturday: "Sábado",
        },
        confirmationModal: {
          deleteTitle: "¿Seguro que quieres excluir este Programa?",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        table: {
          contact: "Contacto",
          body: "Mensaje",
          sendAt: "Fecha del Programa",
          sentAt: "Fecha de Envío",
          status: "Status",
          actions: "Acciones",
        },
        buttons: {
          add: "Nuevo Programa",
        },
        toasts: {
          deleted: "Programa eliminado satisfactoriamente.",
        },
      },
      tags: {
        title: "Tags",
        addColumns: "+ AGREGAR COLUMNAS",
        search: "BUSCAR",
        seeTicket: "VER TICKET",
        searchPlaceholder: "🔍 Buscar tag...",
        newTag: "Nueva Tag",
        viewContacts: "Ver contactos",
        edit: "Editar",
        delete: "Eliminar",
        loading: "⏳ Cargando tags...",
        noTagsFound: "Ninguna tag encontrada",
        confirmationModal: {
          deleteTitle: "¿Seguro que quieres excluir esta Tag?",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        table: {
          id: "ID",
          name: "Nombre",
          tag: "Tag",
          kanban: "Kanban",
          color: "Color",
          tickets: "Registros Tags",
          contacts: "Contactos",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva Tag",
        },
        toasts: {
          deleted: "Tag eliminada satisfactoriamente.",
        },
      },
      tagsKanban: {
        title: "Etapas del Kanban",
        laneDefault: "Abierto(s)",
        backToKanban: "Volver",
        searchPlaceholder: "🔍 Buscar etapa...",
        stage: "Etapa",
        tickets: "Tickets",
        actions: "Acciones",
        noStagesFound: "Ninguna etapa encontrada",
        loading: "⏳ Cargando etapas...",
        loadMore: "Cargar Más",
        loadingMore: "⏳ Cargando...",
        newStage: "Nueva Etapa",
        edit: "Editar",
        delete: "Eliminar",
        confirmationModal: {
          deleteTitle: "¿Seguro que quieres excluir esta Lane?",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        table: {
          name: "Nombre",
          color: "Color",
          tickets: "Tickets",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva Lane",
        },
        toasts: {
          deleted: "Lane eliminada satisfactoriamente.",
        },
      },
      files: {
        title: "Listado de archivos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acción",
        },
        toasts: {
          deleted: "Listado borrado satisfactoriamente!",
          deletedAll: "Todos los listados fueron borrados satisfactoriamente!",
        },
        buttons: {
          add: "Agregar",
          deleteAll: "Borrar Todos",
        },
        confirmationModal: {
          deleteTitle: "Borrar",
          deleteAllTitle: "Borrar Todos",
          deleteMessage: "Estás seguro de borrar este listado?",
          deleteAllMessage: "Estás seguro de borrar todos los listado?",
        },
      },
      settings: {
        success: "Configuración guardada satisfactoriamente.",
        title: "Configuraciones",
        tabs: {
          options: "Opciones",
          plans: "Planes",
          helps: "Ayuda",
          companies: "Empresas",
        },
        settings: {
          userCreation: {
            name: "Creación de usuarios",
            options: {
              enabled: "Habilitado",
              disabled: "Deshabilitado",
            },
          },
          tabs: {
            options: "Opciones",
            schedules: "Horarios",
            plans: "Planes",
            help: "Ayuda",
          },
          options: {
            disabled: "Deshabilitado",
            enabled: "Habilitado",
            updating: "Actualizando...",
            creationCompanyUser: "Creación de Empresa/Usuario",
            evaluations: "Evaluaciones",
            officeScheduling: "Programación de Horario",
            queueManagement: "Gestión por Cola",
            companyManagement: "Gestión por Empresa",
            connectionManagement: "Gestión por Conexión",
            sendGreetingAccepted: "Enviar saludo al aceptar el ticket",
            sendMsgTransfTicket:
              "Enviar mensaje de transferencia de sector/agente",
            checkMsgIsGroup: "Ignorar mensajes de grupos",
            chatBotType: "Tipo de Bot",
            userRandom: "Elegir agente aleatorio",
            buttons: "Botones",
            acceptCallWhatsapp:
              "¿Informar que no se aceptan llamadas por WhatsApp?",
            sendSignMessage: "Permitir al agente elegir ENVIAR firma",
            sendGreetingMessageOneQueues:
              "Enviar saludo cuando haya solo una cola",
            sendQueuePosition: "Enviar mensaje con la posición en la fila",
            sendFarewellWaitingTicket:
              "Enviar mensaje de despedida al estar en espera",
            acceptAudioMessageContact:
              "¿Aceptar audios de todos los contactos?",
            enableLGPD: "Habilitar tratamiento de datos (LGPD)",
            requiredTag: "Etiqueta obligatoria para cerrar el ticket",
            closeTicketOnTransfer: "Cerrar ticket al transferir a otra cola",
            DirectTicketsToWallets:
              "Mover automáticamente al cliente a la cartera",
            showNotificationPending:
              "Mostrar notificación para tickets pendientes",
            enableProfanityMonitor: "Habilitar monitor de palabras inapropiadas",
            copyContactPrefix: "Prefijo para copia de contactos",
            copyContactPrefixPlaceholder: "Ej: COPIA_",
          },
          customMessages: {
            sendQueuePositionMessage: "Mensaje de posición en la fila",
            AcceptCallWhatsappMessage:
              "Mensaje para informar que no se aceptan llamadas",
            greetingAcceptedMessage: "Mensaje de saludo al aceptar el ticket",
            transferMessage:
              "Mensaje de transferencia - ${queue.name} = cola de destino",
          },
          LGPD: {
            title: "Politica de Privacidad",
            welcome: "Mensaje de bienvenida (PP)",
            linkLGPD: "Link de la política de privacidad",
            obfuscateMessageDelete: "Ofuscar mensaje borrada",
            alwaysConsent: "Requerir siempre el consentimiento",
            obfuscatePhoneUser: "Ofuscar número de telefono para usuarios",
            enabled: "Activado",
            disabled: "Desactivado",
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Asignado a:",
          dialogRatingTitle:
            "¿Quieres dejar un mensaje de evaluación para el cliente?",
          dialogClosingTitle: "¡Finalizando la atención al cliente!",
          dialogRatingCancel: "Resolver CON Mensaje de Despedida",
          dialogRatingSuccess: "Resolver y Enviar Evaluación",
          dialogRatingWithoutFarewellMsg: "Resolver SIN Mensaje de Despedida",
          ratingTitle: "Elegir menú de evaluación",
          notMessage: "No hay mensaje seleccionado",
          buttons: {
            return: "Devolver",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceptar",
            rating: "Enviar Evaluación",
            enableIntegration: "Activar/Desactivar integración",
            disableIntegration: "Desactivar integración",
            logTicket: "Logs del Ticket",
            requiredTag:
              "¡Debes asignar una etiqueta antes de cerrar el ticket!",
            resolveAndTriggerIntegration: "Resolver y Disparar Integración",
          },
        },
      },
      messagesInput: {
        placeholderPrivateMessage:
          "Escribe un mensaje o usa / para respuestas rápidas",
        placeholderOpen:
          "Escribe un mensaje o usa / para respuestas rápidas",
        placeholderClosed:
          "Vuelva a abrir o acepte este ticket para enviar un mensaje.",
        signMessage: "Firmar",
        privateMessage: "Mensaje Privado",
      },
      contactDrawer: {
        header: "Detalles del contacto",
        buttons: {
          edit: "Editar contacto",
          block: "Bloquear",
          unblock: "Desbloquear",
        },
        extraInfo: "Otras informaciones",
      },
      messageVariablesPicker: {
        label: "Variables disponibles",
        vars: {
          contactFirstName: "Primer Nombre",
          contactName: "Nombre",
          user: "Agente",
          greeting: "Saludos",
          protocolNumber: "Protocolo",
          date: "Fecha",
          hour: "Hora",
          ticket_id: "Nº del Ticket",
          queue: "Sector",
          connection: "Conexión",
        },
      },
      ticketOptionsMenu: {
        schedule: "Programa",
        delete: "Borrar",
        transfer: "Transferir",
        registerAppointment: "Observaciones del Contacto",
        resolveWithNoFarewell: "Finalizar sin despedida",
        resolveAndTriggerIntegration: "Resolver y Disparar Integración",
        acceptAudioMessage: "¿Aceptar audios del contacto?",
        appointmentsModal: {
          title: "Observaciones del Contacto",
          textarea: "Observación",
          placeholder: "Agregue aqui la información",
        },
        confirmationModal: {
          title: "¿Borrar ticket #",
          titleFrom: "del contacto ",
          message:
            "¡Atención! Todos los mensajes Todos los mensajes relacionados con el ticket se perderán.",
        },
        buttons: {
          delete: "Borrar",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageInput: {
        tooltip: {
          signature: "Activar/Desactivar firma",
          privateMessage: "Activar/Desactivar mensaje privado",
          meet: "Enviar link para videollamada",
        },
        type: {
          imageVideo: "Fotos y videos",
          cam: "Cámara",
          contact: "Contacto",
          meet: "Link Jitsi Meet",
        },
      },
      messageOptionsMenu: {
        delete: "Borrar",
        reply: "Responder",
        edit: "Editar",
        forward: "Enviar",
        toForward: "Enviar",
        talkTo: "Platicar Con",
        confirmationModal: {
          title: "¿Borrar mensaje?",
          message: "Esta acción no puede ser revertida.",
        },
      },
      invoices: {
        title: "Facturas",
        createInvoice: "Crear Nueva Factura",
        editInvoice: "Editar Factura",
        newInvoice: "Nueva Factura",
        generateInvoice: "Generar Factura",
        markAsPaid: "Marcar como Pagado",
        markAsPending: "Marcar como Pendiente",
        invoiceCreated: "¡Factura creada con éxito!",
        invoicePaid: "¡Factura marcada como pagada!",
        viewInvoices: "Ver Facturas",
        noInvoices: "No se encontraron facturas",
        statusUpdated: "¡Estado de la factura actualizado!",
        overdue: "Vencida",
        paid: "Pagada",
        trial: "Trial",
        trialDays: "Días Trial",
        table: {
          invoices: "Facturas",
          details: "Detalles",
          users: "Usuarios",
          connections: "Conexiones",
          queue: "Filas",
          value: "Valor",
          expirationDate: "Fecha Venc.",
          action: "Acción",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP:
          "Debe haber al menos una conexión de WhatsApp predeterminada.",
        ERR_NO_DEF_WAPP_FOUND:
          "No se encontró WhatsApp predeterminado. Verifique la página de conexiones.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sesión de WhatsApp no ​​está inicializada. Verifique la página de conexiones.",
        ERR_WAPP_CHECK_CONTACT:
          "No se pudo verificar el contacto de WhatsApp. Verifique la página de conexiones.",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "No se pudieron descargar los medios de WhatsApp. Verifique la página de conexiones.",
        ERR_INVALID_CREDENTIALS: "Error de autenticación. Vuelva a intentarlo.",
        ERR_SENDING_WAPP_MSG:
          "Error al enviar el mensaje de WhatsApp. Verifique la página de conexiones.",
        ERR_DELETE_WAPP_MSG: "No se pudo borrar el mensaje de WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Ya hay un ticket abierto para este contacto.",
        ERR_SESSION_EXPIRED: "Sesión caducada. Inicie sesión.",
        ERR_USER_CREATION_DISABLED:
          "La creación de usuarios fue deshabilitada por el administrador.",
        ERR_NO_PERMISSION: "No tienes permiso para acceder a este recurso.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_NO_SETTING_FOUND:
          "No se encontró ninguna configuración con este ID.",
        ERR_NO_CONTACT_FOUND: "No se encontró ningún contacto con este ID.",
        ERR_NO_TICKET_FOUND: "No se encontró ningún ticket con este ID.",
        ERR_NO_USER_FOUND: "No se encontró ningún usuario con este ID.",
        ERR_NO_WAPP_FOUND: "No se encontró WhatsApp con este ID.",
        ERR_CREATING_MESSAGE: "Error al crear el mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear el ticket en la base de datos.",
        ERR_FETCH_WAPP_MSG:
          "Error al obtener el mensaje en WhtasApp, tal vez sea demasiado antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Este color ya está en uso, elija otro.",
        ERR_WAPP_GREETING_REQUIRED:
          "El mensaje de saludo es obligatorio cuando hay más de una fila.",
        ERR_OUT_OF_HOURS: "¡Fuera del horario de oficina!",
      },
      messagesAPIInstructions: {
        endpoint: "Endpoint:",
        method: "Método:",
        post: "POST",
        headers: "Headers:",
        headerAuthorization:
          "Authorization Bearer (token registrado) y Content-Type (application/json)",
        body: "Body:",
        fieldNumber: '"number": "558599999999"',
        fieldBody: '"body": "Mensaje"',
        fieldUserId: '"userId": ID de usuario o ""',
        fieldQueueId: '"queueId": ID de la Cola o ""',
        fieldSendSignature: '"sendSignature": Firmar mensaje - true/false',
        fieldCloseTicket: '"closeTicket": Cerrar el ticket - true/false',
        singMessage: "Firmar mensaje - true/false",
        closeTicket: "Cerrar el ticket - true/false",
        testSend: "Prueba de envío",
      },
      recurrenceSection: {
        title: "Recurrencia",
        description:
          "Puede elegir enviar el mensaje de forma recurrente y seleccionar el intervalo. Si es un mensaje único, no cambie nada en esta sección.",
        labelInterval: "Intervalo",
        intervalFilterValue: "Valor del filtro de intervalo",
        sendAsManyTimes: " Enviar tantas veces",
        shipNormallyOnNonbusinessDays: "Envío normal en días no laborables",
        sendOneBusinessDayBefore: "Enviar un día hábil antes",
        sendOneBusinessDayLater: "Enviar un día hábil después",
        options: {
          days: "Días",
          weeks: "Semanas",
          months: "Meses",
          minutes: "Minutos",
        },
      },
      servicePanel: {
        allowRealTime: "Panel de servicio",
      },
      financial: {
        title: "Financiero",
        logout: "Salir",
        alertExpired: "¡Atención! Su suscripción ha vencido. Póngase en contacto con el soporte para regularizar su situación.",
        stats: {
          totalInvoices: "Total de Facturas",
          allInvoices: "Todas las facturas",
          paid: "Pagadas",
          paidInvoices: "Facturas pagadas",
          pending: "Pendientes",
          awaitingPayment: "Esperando pago",
          expired: "Vencidas",
          expiredInvoices: "Facturas vencidas",
          totalValue: "Valor Total",
          sumAllInvoices: "Suma de todas las facturas",
        },
        invoices: "Facturas",
        yourInvoices: "Sus Facturas",
        loading: "Cargando facturas...",
        noInvoices: "No se encontraron facturas",
        invoiceId: "Factura #",
        status: {
          paid: "Pagada",
          pending: "Pendiente",
          expired: "Vencida",
        },
        details: {
          users: "Usuarios",
          connections: "Conexiones",
          queues: "Colas",
          dueDate: "Vencimiento",
        },
        buttons: {
          payNow: "Pagar Ahora",
          paid: "Pagada",
        },
        invoices: "Facturas",
        details: "Detalles",
        users: "Usuarios",
        connections: "Conexiones",
        queues: "Colas",
        value: "Valor",
        expirationDate: "Fecha Venc.",
        action: "Acción",
      },
      statusFilter: {
        statusFilter: "Filtrar por estado",
      },
      momentsUser: {
        services: "Servicios:",
        pending: "Pendiente",
        noqueue: "SIN COLA",
      },
      campaignsPhrase: {
        campaignsFlow: "Flujo de Campaña",
        campaigns: "Campaña",
        name: "Nombre",
        status: "Estado",
        newCampaignWithFlowByPhrase: "Nueva campaña con flujo por frase",
        editCampaignWithFlowByPhrase: "Editar campaña con flujo por frase",
        phraseTriggerName: "Nombre del disparador de frase",
        chooseAStream: "Elige una transmisión",
        whichPhraseTriggersTheFlow: " ¿Qué frase desencadena el flujo?",
        selectAConnection: "Seleccione una conexión",
        chooseAStream: "Elige una transmisión",
        status: " Estado",
        cancel: "CANCELAR",
        createCampaign: "CREAR CAMPAÑA ",
        saveCampaign: "Guardar Campaña",
      },
      whatsappModalRel: {
        form: {
          isOficial: "Informe de Soporte",
          ticketId: "ID del Ticket",
          client: "Cliente",
          number: "Número",
          agent: "Agente",
          date: "Fecha",
          lastMessage: "Último Mensaje",
          fullReport: "El informe completo está adjunto arriba",
          resolveAndTriggerIntegration: "Resolver y Disparar Integración",
          elementNotFoundForExport: "Elemento no encontrado para exportar.",
          reportFilename: "informe_soporte",
        },
      },
      chatList: {
        noMessages: "Sin mensajes",
        admin: "Administrador",
        member: "Miembro",
        searchChat: "Buscar chat...",
        createNewChat: "Crear nuevo chat",
        searchUser: "Buscar usuario...",
        noUserFound: "No se encontró usuario",
        noUserAvailable: "No hay usuarios disponibles",
        cancel: "Cancelar",
        details: "Detalles",
        deleteChat: "Eliminar Chat",
        deleteChatConfirm: "Esta acción no se puede deshacer, ¿confirmar?",
        detailsTitle: "Detalles",
        edit: "Editar",
        delete: "Eliminar",
        now: "ahora",
        minutesAgo: "hace {{count}}m",
        hoursAgo: "hace {{count}}h",
        errorLoadingUsers: "Error al cargar usuarios",
        chatAlreadyExists: "El chat con este usuario ya existe!",
        chatCreated: "Chat creado con éxito!",
        errorCreatingChat: "Error al crear chat",
        group: "Grupo",
        user: "Usuario",
        audio: "[Audio]",
        image: "[Imagen]",
        video: "[Video]",
        file: "[Archivo]",
      },
      chatMessages: {
        deleted: "Este mensaje fue eliminado",
        deletedAdmin: "Mensaje eliminado - visible solo para administradores",
        reply: "Responder",
        edit: "Editar",
        delete: "Eliminar",
        forward: "Reenviar",
        editMessage: "Editar Mensaje",
        save: "Guardar",
        cancel: "Cancelar",
        deleteMessage: "Eliminar Mensaje",
        deleteMessageConfirm:
          "¿Está seguro de que desea eliminar este mensaje?",
        forwardMessage: "Reenviar Mensaje",
        selectChat: "Seleccione el chat",
        doubleClickToReply: "Doble clic para responder",
        edited: "(editado)",
        forwarded: "(reenviado)",
        typeMessage: "Escribe un mensaje...",
        send: "Enviar",
        noMessages: "Sin mensajes",
        loading: "Cargando...",
        replyingTo: "Respondiendo a",
        clickToGoToOriginal: "Haga clic para ir al mensaje original",
      },
      chatPopover: {
        reply: "Responder",
        edit: "Editar",
        delete: "Eliminar",
        forward: "Reenviar",
        cancel: "Cancelar",
        confirmDelete: "Confirmar Eliminación",
        confirm: "Confirmar",
        editMessage: "Editar Mensaje",
        save: "Guardar",
        forwardMessage: "Reenviar Mensaje",
        selectChat: "Seleccione el chat",
        forward: "Reenviar",
        noChats: "No hay chats disponibles",
      },
      chatIndex: {
        chats: "Chats",
        groups: "Grupos",
        new: "+ Nuevo",
        selectChat: "Seleccione un chat",
        selectChatMessage: "Elija un chat de la lista para comenzar a conversar",
        messages: "Mensajes",
        search: "Buscar...",
        noChats: "No se encontraron chats",
        noGroups: "No se encontraron grupos",
        noMessages: "Sin mensajes",
        loading: "Cargando...",
        error: "Error al cargar los datos",
        addGroupPhoto: "Agregar Foto de Grupo",
        changeGroupPhoto: "Cambiar Foto de Grupo",
        groupName: "Nombre del Grupo",
        groupDescription: "Descripción del Grupo",
        save: "Guardar",
        cancel: "Cancelar",
        createGroup: "Crear Grupo",
        editGroup: "Editar Grupo",
        deleteGroup: "Eliminar Grupo",
        deleteGroupConfirm: "¿Está seguro de que desea eliminar este grupo?",
        edit: "Editar",
        delete: "Eliminar",
        details: "Detalles",
        groupDetails: "Detalles del Grupo",
        title: "Título",
        description: "Descripción",
        modal: {
          title: "Crear Grupo",
          editTitle: "Editar Grupo",
          save: "Guardar",
          cancel: "Cancelar",
          description: "Ingrese el nombre y la descripción del grupo.",
          name: "Nombre del Grupo",
          create: "Crear",
          edit: "Editar",
        },
      },
      birthdaySettings: {
        title: "Configuraciones de Cumpleaños",
        loading: "Cargando configuraciones...",
        userSection: "Cumpleaños de Usuarios",
        contactSection: "Cumpleaños de Contactos",
        generalSection: "Configuraciones Generales",
        enableUserBirthday: "Habilitar notificaciones de cumpleaños de usuarios",
        enableUserBirthdayDesc: "Cuando está habilitado, se mostrará un modal de felicitaciones y se creará un informativo automático",
        createAnnouncement: "Crear informativo automático para cumpleaños de usuarios",
        createAnnouncementDesc: "Crea un informativo automático que se muestra para todos los usuarios de la empresa",
        userBirthdayMessage: "Mensaje de cumpleaños para usuarios",
        useNameVariable: "Use {nome} para incluir el nombre del usuario",
        enableContactBirthday: "Habilitar envío automático de mensajes de cumpleaños para contactos",
        enableContactBirthdayDesc: "Envía automáticamente mensaje de felicitaciones vía WhatsApp para contactos que cumplen años",
        contactBirthdayMessage: "Mensaje de cumpleaños para contactos",
        useNameAgeVariable: "Use {nome} para incluir el nombre del contacto y {idade} para la edad",
        testMessage: "Probar Mensaje",
        sendTime: "Horario de Envío",
        sendTimeDesc: "Horario en que los mensajes automáticos serán enviados",
        whatsappConnection: "Conexión WhatsApp para Envío",
        whatsappConnectionDesc: "Conexión WhatsApp que será usada para enviar mensajes de cumpleaños",
        selectConnection: "Seleccione una conexión",
        variablesTitle: "Variables disponibles en los mensajes:",
        variableName: "Nombre de la persona",
        variableAge: "Edad de la persona (solo para contactos)",
        saving: "Guardando...",
        saveSettings: "Guardar Configuraciones",
        preview: "Vista previa:",
        toasts: {
          loadError: "Error al cargar configuraciones de cumpleaños",
          saveSuccess: "¡Configuraciones de cumpleaños guardadas con éxito! 🎉",
          saveError: "Error al guardar configuraciones",
          testSuccess: "¡Mensaje de prueba enviado! 📱",
          testError: "Error al enviar mensaje de prueba",
        },
      },
      whitelabel: {
        primaryColorLight: "Color Primario (Tema Claro)",
        primaryColorDark: "Color Primario (Tema Oscuro)",
        listItemBgColor: "Color de Fondo del Menú Activo",
        appName: "Nombre de la Aplicación",
        logoLight: "Logo (Tema Claro)",
        logoDark: "Logo (Tema Oscuro)",
        favicon: "Favicon",
        backgroundLight: "Imagen de Fondo (Tema Claro)",
        backgroundDark: "Imagen de Fondo (Tema Oscuro)",
        preview: "Vista Previa",
        delete: "Eliminar",
        upload: "Subir",
        availableLanguages: "Idiomas Disponibles",
        atLeastOneLanguage: "Al menos un idioma debe estar habilitado",
        sections: {
          general: "Configuraciones Generales",
          generalDescription: "Configura el nombre y la información básica de la aplicación",
          colors: "Colores y Temas",
          colorsDescription: "Personaliza los colores primarios para los temas claro y oscuro",
          logos: "Logos e Imágenes",
          logosDescription: "Sube los logos e imágenes de fondo de la aplicación",
          languages: "Idiomas Disponibles",
          languagesDescription: "Selecciona qué idiomas estarán disponibles en el sistema",
        },
      },
      systemSettings: {
        restartBackend: "Reiniciar Servicio de API",
        restarting: "Reiniciando...",
        saveConfig: "Guardar Configuración",
        saving: "Guardando...",
        enableAutoRestart: "Activar Reinicio Automático",
        enableAutoCleanup: "Activar Limpieza Automática",
        enableAutoBackup: "Activar Backup Automático (24 horas)",
        confirmRestartBackend: "¿Está seguro de que desea reiniciar el backend? El servidor estará no disponible por algunos segundos.",
        confirmRestartVPS: "¡¡ATENCIÓN!! ¿Está seguro de que desea reiniciar el VPS completo? Todos los servicios estarán no disponibles por algunos minutos.",
        confirmRestore: "Para confirmar la restauración, escriba exactamente: CONFIRMAR",
        restoreCancelled: "Restauración cancelada - confirmación incorrecta",
        invalidNumber: "Ingrese un número válido",
        videoSizeError: "El tamaño del video debe ser mayor que 0",
        configSaved: "¡Configuración guardada! El reinicio automático se implementará pronto.",
        configSaveError: "Error al guardar configuración de reinicio: ",
        backendRestarting: "El backend se reiniciará en 3 segundos...",
        vpsRestarting: "El VPS se reiniciará en 5 segundos...",
        cleanupEnabled: "¡Limpieza automática activada!",
        cleanupDisabled: "¡Limpieza automática desactivada!",
        cleanupError: "Error al alternar limpieza: ",
        cleanupSaved: "¡Configuración de limpieza guardada con éxito!",
        configError: "Error al guardar configuración: ",
        backupEnabled: "¡Backup automático activado!",
        backupDisabled: "¡Backup automático desactivado!",
        backupError: "Error al alternar backup automático: ",
        invalidSqlFile: "Por favor, seleccione un archivo .sql válido",
        analysisDisabled: "Función de análisis temporalmente deshabilitada para estabilidad",
        configUpdated: "¡Configuración actualizada con éxito!",
        noPermission: "¡Esta empresa no tiene permiso para acceder a esta página! Redirigiendo...",
      },
      subscription: {
        licensePeriod: "Período de Licencia",
        licenseExpiresIn: "Su licencia vence en",
        licenseExpiresToday: "¡Su licencia vence hoy!",
        licenseExpiresDays: "días",
        billingEmail: "Email de facturación",
      },
      settingsTabs: {
        schedules: "Horarios",
        finalization: "Finalización de Atención",
        finalizationDescription: "Descripción (opcional)",
      },
      kanbanCard: {
        observation: "Observación",
        observationPlaceholder: "Escriba sus observaciones sobre el cliente...",
        manageKanban: "Gestionar kanban de usuario",
      },
      ticketActionButtons: {
        quickResponses: "Respuestas Rápidas",
        linkToWallet: "Vincular a Cartera",
        returnToQueue: "Devolver a la Cola",
        mandatoryRating: "Evaluación obligatoria",
        tokenError: "Error: Token o número de teléfono no disponible.",
      },
      ticketInfoPanel: {
        updatedSuccess: "¡Información actualizada con éxito!",
        groupInfo: "Información del Grupo",
        noImage: "No se encontró ninguna imagen",
        noVideo: "No se encontró ningún video",
        noAudio: "No se encontró ningún audio",
        infoLabel: "Información",
        videosLabel: "Videos",
        audiosLabel: "Audios",
      },
      scheduleModalExtra: {
        messagePlaceholder: "Escriba el mensaje que será enviado...",
        quickResponses: "⚡ Respuestas Rápidas",
        quickResponsesSearch: "Escriba para buscar respuestas rápidas...",
        fromQuickResponse: "De Respuesta Rápida",
        responsibleUser: "👤 Usuario Responsable",
        signMessage: "✍️ Firmar mensaje con nombre del usuario",
        businessDays: "Días Hábiles",
      },
      quickMessageDialog: {
        editMedia: "Editar multimedia",
        removeMedia: "Eliminar multimedia",
        newAudioRecorded: "Nuevo audio grabado",
        newAudio: "Nuevo Audio",
      },
      ticketsManagerTabs: {
        searchTooltip: "Marque para buscar también en el contenido de los mensajes (más lento)",
      },
      smtpConfig: {
        emailUser: "Email (Usuario)",
        loadError: "Error al cargar configuraciones SMTP",
        saveSuccess: "¡Configuraciones SMTP guardadas con éxito!",
        saveError: "Error al guardar configuraciones SMTP",
      },
      settingsOptions: {
        wavoipEmail: "Email/Usuario Wavoip",
        transferMessage: "Mensaje de transferencia - ${queue.name} = cola destino",
        greetingAcceptedMessage: "Mensaje de Saludo al aceptar ticket",
        acceptCallMessage: "Mensaje para informar que no acepta llamadas",
        queuePositionMessage: "Mensaje de posición en la cola",
      },
      versionControl: {
        newVersion: "¡Nueva versión disponible!",
        clickToUpdate: "Haga clic en actualizar para obtener las últimas mejoras.",
        updateError: "Error en la actualización:",
      },
      flowBuilder: {
        variableName: "Nombre de la variable",
        variableHelper: "Puede usar valores estáticos o referencias como ${otraVariable}",
        selectPreset: "Seleccionar preset",
        selectPresetPlaceholder: "Elija una configuración lista...",
        method: "Método",
        conditionHelper: "Puede ser texto fijo o variable (ej: ${variable})",
      },
      plansManager: {
        integrations: "Integraciones",
        deleteTitle: "Eliminación de Registro",
      },
      usersPage: {
        confirmGenerateChats: "¿Está seguro de que desea generar chats para todos los usuarios existentes? Esto puede tardar y crear muchos chats.",
        user: "usuario",
        users: "usuarios",
        permissions: "Permisos",
      },
      whatsappModalExtra: {
        defaultFlow: "Flujo Predeterminado",
        saveChanges: "Haga clic en guardar para registrar los cambios",
      },
      messagesAPIExtra: {
        authToken: "Token de Autenticación",
        authTokenHelper: "Token registrado en el sistema para autenticación",
        recipientNumber: "Número del Destinatario",
        recipientNumberHelper: "Formato: código de país + código de área + número (ej: 5585999999999)",
        userIdLabel: "ID del Usuario/Agente",
        userIdHelper: "Opcional - ID del agente que enviará el mensaje",
        mediaCaption: "Leyenda de la Multimedia",
        mediaCaptionHelper: "Opcional - Texto que acompañará la multimedia",
        mediaMessage: "Mensaje con Multimedia",
        advanced: "Avanzado",
      },
    },
  },
};

export { messages };